// Narrow, temporary release dispositions approved on 2026-10-07.
// This is not the original canonical authority or a country-wide exclusion.
import { normalizeReleaseRoutePath, releaseRedirectRule } from "./release-route-redirect-map.mjs";
export const LEGACY_404_RELEASE_PATHS = new Set([
  "/uk/9900", "/uk/2900", "/uk/1600", "/uk/1300", "/uk/1000",
  "/uk/880", "/uk/720", "/uk/590", "/uk/480", "/uk/320",
  "/se/170", "/se/720", "/se/140", "/se/260", "/se/90",
  "/nz/390", "/nz/260", "/ca/page ranked:", "/za/page ranked:",
  "/uk/Visits", "/nz/Visits",
  "/ca/important-key-words-we-should-keep-track-of",
  "/za/important-key-words-we-should-keep-track-of",
]);
// All six proven noindex review stubs now have a better public target. Retain
// this separate branch for future reviewed noindex pages WITHOUT such a target.
export const LEGACY_NOINDEX_RELEASE_PATHS = new Set([]);
export const BEN_SOURCE_GAP_RELEASE_PATHS = new Set([]);
export function releaseRouteDisposition(pathname) {
  const path = normalizeReleaseRoutePath(pathname);
  if (releaseRedirectRule(path)) return "modern-target-301";
  if (LEGACY_404_RELEASE_PATHS.has(path)) return "legacy-404";
  if (LEGACY_NOINDEX_RELEASE_PATHS.has(path)) return "legacy-noindex";
  if (BEN_SOURCE_GAP_RELEASE_PATHS.has(path)) return "ben-source-gap-unverified";
  return null;
}
